import { defineMessages } from 'react-intl'

const scope = `procurify.components.PaymentDetailsCard`

export default defineMessages({
  cardAriaLabel: {
    id: `${scope}.cardAriaLabel`,
    defaultMessage: 'Spending card {cardNumber}',
  },
  visaLogoAltText: {
    id: `${scope}.visaLogoAltText`,
    defaultMessage: 'Visa logo',
  },
  pendingLabel: {
    id: `${scope}.pendingLabel`,
    defaultMessage: 'This card is pending',
  },
  lockedLabel: {
    id: `${scope}.lockedLabel`,
    defaultMessage: 'This card is locked',
  },
  canceledLabel: {
    id: `${scope}.canceledLabel`,
    defaultMessage: 'This card is canceled',
  },
  availableBalanceLabel: {
    id: `${scope}.availableBalanceLabel`,
    defaultMessage: 'Available balance',
  },
  paymentDetailsLabel: {
    id: `${scope}.paymentDetailsLabel`,
    defaultMessage: 'Payment details',
  },
  showDetailsButtonText: {
    id: `${scope}.showDetailsButtonText`,
    defaultMessage: 'Show details',
  },
  hideDetailsButtonText: {
    id: `${scope}.hideDetailsButtonText`,
    defaultMessage: 'Hide details',
  },
})
